<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="通告类型">
              <a-select style="width: 270px" placeholder="请选择" v-model="queryParam.msgType">
                <a-select-option value="0"> 全部 </a-select-option>
                <!-- <a-select-option value="1"> 待办事项 </a-select-option> -->
                <a-select-option value="2"> 系统提醒 </a-select-option>
                <a-select-option value="3"> 常用工具 </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!-- <a-col :span="6">
            <a-form-item label="标题">
              <a-input placeholder="请输入标题" v-model="queryParam.titile"></a-input>
            </a-form-item>
          </a-col> -->
          <!--<a-col :span="6">
            <a-form-item label="内容">
              <a-input placeholder="请输入内容" v-model="queryParam.msgContent"></a-input>
            </a-form-item>
          </a-col>-->

          <a-col :span="8">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd('add')" type="primary" icon="plus">新增</a-button>
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('系统通告')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
				<a-menu slot="overlay">
					<a-menu-item key="1" @click="batchDel">
						<a-icon type="delete" />
						删除
					</a-menu-item>
				</a-menu>
				<a-button style="margin-left: 8px">
					批量操作
					<a-icon type="down" />
				</a-button>
			</a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
				<i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
				<a style="font-weight: 600">{{ selectedRowKeys.length }}</a
				>项
				<a style="margin-left: 24px" @click="onClearSelected">清空</a>
			</div> -->

      <!-- :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" -->
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a-divider type="vertical" v-if="record.sendStatus == 0" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.enableStatus == 0">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleEdit(record, 'edit')">编辑</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleDetail(record, 'details')">查看</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <sysAnnouncement-modal ref="modalForm" @ok="modalFormOk"></sysAnnouncement-modal>
  </a-card>
</template>

<script>
import SysAnnouncementModal from './modules/SysAnnouncementModal'
import { doReleaseData, doReovkeData } from '@/api/api'
import { getAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'

export default {
  name: 'SysAnnouncementList',
  mixins: [JeecgListMixin],
  components: {
    SysAnnouncementModal
  },
  data() {
    return {
      description: '系统通告表管理页面',
      // 查询条件
      queryParam: {},
      // 表头
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function (t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '标题',
          align: 'center',
          dataIndex: 'title'
        },
        {
          title: '通告类型',
          align: 'center',
          dataIndex: 'msgType',
          customRender: function (text) {
            if (text == '0') {
              return '全部'
            }
            // else if ( text == '1' ) {
            // 	return '待办事项'
            // }
            else if (text == '2') {
              return '系统提醒'
            } else {
              return '常用工具'
            }
          }
        },
        /*{
            title: '开始时间',
            align: "center",
            dataIndex: 'startTime'
          },
          {
            title: '结束时间',
            align: "center",
            dataIndex: 'endTime'
          },*/
        {
          title: '优先级',
          align: 'center',
          dataIndex: 'priority',
          customRender: function (text) {
            if (text == 'L') {
              return '低'
            } else if (text == 'M') {
              return '中'
            } else if (text == 'H') {
              return '高'
            } else {
              return text
            }
          }
        },
        {
          title: '发布对象',
          align: 'center',
          dataIndex: 'publishObjDesc'
          // customRender: function (text) {
          //   if (text.split(',')[0] == '0') {
          //     return "全部";
          //   } else if (text == "1") {
          //     return "公司员工";
          //   } else if (text == "2") {
          //     return "投标人/供应商";
          //   }  else if (text == "3") {
          //     return "招标人";
          //   }  else if (text == "4") {
          //     return "专家";
          //   }
          // }
        },
        {
          title: '发布状态',
          align: 'center',
          dataIndex: 'isPublish',
          customRender: function (text) {
            if (text == 0) {
              return '未发布'
            } else if (text == 1) {
              return '已发布'
            } else if (text == 2) {
              return '已撤销'
            } else {
              return text
            }
          }
        },
        {
          title: '发布时间',
          align: 'center',
          dataIndex: 'publishTime'
        },
        {
          title: '发布人',
          align: 'center',
          dataIndex: 'createBy'
        },
        {
          title: '启用状态',
          align: 'center',
          dataIndex: 'enableStatus',
          customRender: function (text) {
            if (text == 0) {
              return '禁用'
            } else if (text == 1) {
              return '启用'
            }
          }
        },
        /*{
                title: '删除状态（0，正常，1已删除）',
                align:"center",
                dataIndex: 'delFlag'
              },*/
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/announcement/list',
        delete: '/api/announcement/delete',
        deleteBatch: '/api/announcement/deleteBatch',
        releaseDataUrl: '/api/announcementRead/doReleaseData',
        reovkeDataUrl: '/api/sys/annountCement/doReovkeData',
        exportXlsUrl: '/api/sys/annountCement/exportXls',
        importExcelUrl: '/api/sys/annountCement/importExcel'
      }
    }
  },
  computed: {
    importExcelUrl: function () {
      return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`
    }
  },
  methods: {
    //执行发布操作
    releaseData: function (id) {
      console.log(id)
      var that = this
      doReleaseData({ id: id }).then((res) => {
        if (res.success) {
          that.$message.success(res.message)
          that.loadData(1)
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    //执行撤销操作
    reovkeData: function (id) {
      var that = this
      doReovkeData({ id: id }).then((res) => {
        if (res.success) {
          that.$message.success(res.message)
          that.loadData(1)
          this.syncHeadNotic(id)
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    syncHeadNotic(anntId) {
      getAction('/api/sys/annountCement/syncNotic', { anntId: anntId })
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
